<template>
    <div
        :style="{
            width: sizes.width,
            height: sizes.height,
            border: 'solid 1px black',
            overflow: 'hidden',
        }"
    >
        <splitpanes
            class="default-theme"
            horizontal
            :style="{
                height: sizes.height,
            }"
        >
            <pane max-size="80" min-size="20" size="80">
                <o-cross-table
                    :cell-width="cellWidth"
                    :column-headers="columnHeaders"
                    :column-headers-config="columnHeadersConfig"
                    :debug="debug"
                    :row-headers="rowHeaders"
                    :row-headers-config="rowHeadersConfig"
                    :row-label-width="rowLabelWidth"
                    :values="values"
                    @hover="selectionChanged"
                    ref="ValuesTable"
                >
                    <template slot="header-cell" slot-scope="{ item }">
                        <slot :item="item" name="header-cell"></slot>
                    </template>
                    <template slot="row-header" slot-scope="{ item }">
                        <slot :item="item" name="row-header"></slot>
                    </template>
                    <template
                        slot="value-cell"
                        slot-scope="{ items, rowHeader, colHeader, itemKey }"
                    >
                        <div
                            @click="addSelected(rowHeader, colHeader)"
                            class="oja-add-here"
                            v-if="selected_task"
                        >
                            Add Here
                        </div>
                        <Drop
                            @dragover="dragover(colHeader, rowHeader)"
                            @drop="dropped(rowHeader, colHeader, ...arguments)"
                            class="oja-drop-cell"
                            tag="div"
                        >
                            <div
                                :class="
                                    _calc_allocation_cell_class(
                                        item,
                                        colHeader,
                                        rowHeader
                                    )
                                "
                                :key="itemKey + '-' + itemidx"
                                :id="itemKey + '-' + itemidx"
                                class="oja-cell"
                                v-for="(item, itemidx) in items"
                                tabindex="0"
                            >
                                <Drag :transfer-data="item">
                                    <slot
                                        :colHeader="colHeader"
                                        :item="item"
                                        :rowHeader="rowHeader"
                                        name="allocation-cell"
                                    ></slot>
                                </Drag>
                                <b-popover
                                    :target="itemKey + '-' + itemidx"
                                    custom-class="popover-main"
                                    triggers="click blur"
                                >
                                    <b-list-group>
                                        <b-list-group-item
                                            @click="edit(item)"
                                            href="#"
                                            v-if="showMenuOptionEdit"
                                        >
                                            Edit
                                        </b-list-group-item>
                                        <b-list-group-item
                                            @click="unallocate(item)"
                                            href="#"
                                            v-if="showMenuOptionDelete"
                                        >
                                            Delete
                                        </b-list-group-item>
                                    </b-list-group>
                                </b-popover>
                            </div>
                        </Drop>
                    </template>
                </o-cross-table>
            </pane>
            <pane max-size="80" min-size="20" :class="lower_pane_class">
                <template v-if="taskPool">
                    <div
                        :key="item_no"
                        class="oja-pool-element"
                        v-for="(item, item_no) in tasks"
                    >
                        <div class="oja-drop-cell oja-task-pool-cell">
                            <Drop
                                @drop="droppedTask($event)"
                                class="oja-drop-cell"
                                tag="div"
                            >
                                <div
                                    :class="_calc_task_cell_class(item)"
                                    :key="item_no"
                                    @click="selectItem(item)"
                                >
                                    <Drag :transfer-data="item">
                                        <slot
                                            :item="item"
                                            name="task-item"
                                        ></slot>
                                    </Drag>
                                </div>
                            </Drop>
                        </div>
                    </div>
                </template>
                <o-cross-table
                    :cell-width="cellWidth"
                    v-if="!taskPool"
                    :column-headers="columnHeaders"
                    :column-headers-config="columnHeadersConfig"
                    :debug="debug"
                    :row-headers="taskRowHeaders"
                    :row-headers-config="tasksRowConfig"
                    :row-label-width="rowLabelWidth"
                    :values="tasks"
                    @hover="taskSelectionChanged"
                    ref="TasksTable"
                >
                    <template slot="header-cell" slot-scope="{ item }">
                        <slot :item="item" name="header-cell"></slot>
                    </template>
                    <template slot="row-header" slot-scope="{ item }">
                        <slot :item="item" name="task-row-header"></slot>
                    </template>
                    <template
                        slot="value-cell"
                        slot-scope="{ items, rowHeader, colHeader, itemKey }"
                    >
                        <div class="oja-drop-cell">
                            <Drop
                                @drop="droppedTask($event)"
                                class="oja-drop-cell"
                                tag="div"
                            >
                                <div
                                    :class="_calc_task_cell_class(item)"
                                    :key="item_no"
                                    @click="selectItem(item)"
                                    v-for="(item, item_no) in items"
                                >
                                    <Drag :transfer-data="item">
                                        <slot
                                            :item="item"
                                            name="task-item"
                                        ></slot>
                                    </Drag>
                                </div>
                            </Drop>
                        </div>
                    </template>
                </o-cross-table>
            </pane>
        </splitpanes>
    </div>
</template>

<script>
import _ from "lodash";
import { Drag, Drop } from "vue-drag-drop";
import OCrossTable from "../table/OCrossTable";
import { vueWindowSizeMixin } from "vue-window-size";
import { Pane, Splitpanes } from "splitpanes";
import "splitpanes/dist/splitpanes.css";
/* This screen allocates "Jobs" for each Resource (Left Hand Side) and When (Top Header)

        Resources can be nested.. ie Driver, Run etc..

     */

export default {
    name: "OJobAllocation",
    mixins: [vueWindowSizeMixin],
    components: {
        OCrossTable,
        Drag,
        Drop,
        Splitpanes,
        Pane, // for split
    },
    data() {
        return {
            selected_row: null,
            selected_col: null,
            selected_task: null, //selected Task
        };
    },
    props: {
        rowHeaders: {
            type: Array,
            default: () => [],
        } /* List of Row Headers on Left Hand Side*/,
        rowHeadersConfig: {
            type: Array,
            default: () => [
                {
                    key: "id",
                    children_key: "children",
                    title: "Resource Y - 1",
                    item_key: "res2_id",
                },
            ],
        },

        columnHeaders: {
            type: Array,
            default: () => [],
        } /* List of Column Headers across the Top */,
        /* Config how to read columnHeaders,
                key=Field name for unique field name of the id of the Column header to match with the Value[item_key]
                children_key= Field name for children list for next level or NULL for no children
                title= Title to show for the Level
                item_key: The KEY field on the Value for this level
             */
        columnHeadersConfig: {
            type: Array,
            default: () => [
                {
                    key: "id",
                    children_key: "children",
                    title: "Resource X - 1",
                    item_key: "column_id",
                },
            ],
        },

        values: { type: Array, default: () => [] } /* The Allocation data */,

        tasks: { type: Array, default: () => [] } /* List of Tasks on Bottom */,
        taskRowHeaders: {
            type: Array,
            default: () => [{ id: true, name: "Tasks" }],
        },
        tasksRowConfig: {
            type: Array,
            default: () => [
                {
                    key: "id",
                    children_key: "children",
                    title: "Resource X - 1",
                    item_key: "res_id",
                },
            ],
        },
        tasksNewKey: {
            type: String,
            default: "_new",
        } /* the Key in the Tasks differentiate from an Allocation */,

        taskUniqueKeyInCell: {
            type: String,
            default: null,
        } /* The Unique key in the Cell to ensure no duplicates. When null only 1 entry per cell */,

        cellClass: { type: Function, default: null },

        cellWidth: {
            type: String,
            default: "100px",
        } /* Width of the Allocation Column */,
        rowLabelWidth: {
            type: String,
            default: "100px",
        } /* Width of the Row Label column */,

        debug: { type: Boolean, default: false },

        canAllocate: { type: Function, default: null },
        showMenuOptionEdit: { type: Boolean, default: false },
        showMenuOptionDelete: { type: Boolean, default: false },
        taskPool: { type: Boolean, default: false },
    },
    methods: {
        unallocate(allocation) {
            // remove it!
            var index = this.values.indexOf(allocation);

            if (index > -1) {
                this.$delete(this.values, index);

                this.$emit("remove", allocation);
            }
        },
        edit(allocation) {
            this.$emit("edit", allocation);
        },
        addSelected(rowIDS, colIDS) {
            if (this.selected_task) {
                this.dropped(rowIDS, colIDS, this.selected_task, {
                    ctrlKey: false,
                });
            }
        },
        droppedTask(data) {
            if (this.tasksNewKey in data) {
                // An Job is dropped on the Jobs table so  ignore it
            } else {
                // An allocation is dropped on the Jobs table
                this.unallocate(data);
            }
        },
        dropped(rowIDS, colIDS, data, nativeEvent) {
            var allocation = data;

            var isNew = false;
            var isCopy = false;

            if (this.tasksNewKey in data) {
                isNew = true;
            }

            if (nativeEvent.ctrlKey == true) {
                isNew = true;
                isCopy = true;
            }

            var allKeys = {};

            _.each(this.columnHeadersConfig, function (res_config, index) {
                allKeys[res_config.item_key] = colIDS.id[index];
            });
            _.each(this.rowHeadersConfig, function (res_config, index) {
                allKeys[res_config.item_key] = rowIDS.id[index];
            });

            var canCreateAllocation = true;

            if (this.canAllocate && _.isFunction(this.canAllocate)) {
                canCreateAllocation = this.canAllocate(allKeys, data);
            }
            if (canCreateAllocation) {
                if (isNew) {
                    allocation = _.cloneDeep(data); // New one!
                    if (!isCopy) {
                        delete allocation[this.tasksNewKey];
                    } else {
                        delete allocation["id"]; // remove the 'id'
                        delete allocation["pk"]; // remove the 'id'
                    }
                }
                allocation = Object.assign(allocation, allKeys); // update the keys

                // if there is a value also check this taskUniqueKeyInCell field in the allocation
                if (this.taskUniqueKeyInCell) {
                    allKeys[this.taskUniqueKeyInCell] =
                        allocation[this.taskUniqueKeyInCell];
                }

                if (!isNew) {
                    this.$emit("update", allocation);
                } else {
                    var found = _.find(this.values, allKeys);

                    // only add if new and original
                    if (!found) {
                        this.values.push(allocation);

                        this.$emit("add", allocation);
                    }
                }
            }
        },
        taskSelectionChanged(cell) {
            /* When they hover over the Task Table */
            if (cell.col) {
                this.selected_col = cell.col.id;
            } else {
                this.selected_col = null;
            }
            this.$refs.ValuesTable.selected_col = this.selected_col; // update other table?

            if (this.$refs.TasksTable) {
                this.$refs.TasksTable.selected_row = null; // don't highlight rows on this table
            }
        },
        selectionChanged(cell) {
            /* When they hover over the Allocation Table */
            if (cell.row) {
                this.selected_row = cell.row.id;
            } else {
                this.selected_row = null;
            }
            if (cell.col) {
                this.selected_col = cell.col.id;
            } else {
                this.selected_col = null;
            }

            if (this.$refs.TasksTable)
                this.$refs.TasksTable.selected_col = this.selected_col; // update other table
        },
        dragover(row, col) {
            /* Highlight the Row + column we are over while Dragging in Allocation Table*/

            if (col) {
                this.selected_row = col.id;
            }

            if (row) {
                this.selected_col = row.id;
            }

            this.$refs.ValuesTable.selected_col = this.selected_col; // update ValuesTable
            this.$refs.ValuesTable.selected_row = this.selected_row; // update ValuesTable

            if (this.$refs.TasksTable)
                this.$refs.TasksTable.selected_col = this.selected_col; // update TasksTable
        },
        _calc_task_cell_class(item) {
            var result = {
                "oja-task-item": item != this.selected_task,
                "oja-selected-task-item": this.selected_task == item,
            };

            if (this.cellClass != null && _.isFunction(this.cellClass)) {
                result = { ...result, ...this.cellClass(item, null, null) };
            }
            result["oja-active"] = item != null;
            return result;
        },
        _calc_allocation_cell_class(item, resource, task) {
            var result = {};

            if (this.cellClass != null && _.isFunction(this.cellClass)) {
                result = this.cellClass(item, task, resource);
            }

            result["oja-active"] = item != null;
            return result;
        },
        selectItem(item) {
            if (this.selected_task == item) {
                this.selected_task = null;
            } else {
                this.selected_task = item;
            }
        },
    },
    computed: {
        lower_pane_class() {
            if (this.taskPool) {
                return "oja-pool";
            } else {
                return "";
            }
        },
        sizes() {
            return {
                width: this.windowWidth - 30 + "px",
                height: this.windowHeight - 161 + "px",
            };
        },
    },
};
</script>

<style scoped>
.debug {
    font-size: 6pt;
}

.oja-add-here {
    position: relative;
    top: 0px;
    left: 0px;
    border: solid 1px silver;
    width: 100%;
    display: block;
    text-align: center;
    cursor: pointer;
}

div.oja-drop-cell {
    width: 100%;
    height: 100%;
    min-height: 24px;
}

.oja-cell {
    background: #ececec;
    opacity: 0.5;
    min-width: 26px;
    min-height: 26px;
    display: block;
    cursor: pointer;
    margin-bottom: 5px;
}

.oja-task-item {
    display: block;
    border: 1px solid silver;
    background-color: rgba(99, 255, 82, 0.41);
}

.oja-selected-task-item {
    display: block;
    border: 4px solid black;
    filter: saturate(250%);
}

.oja-active {
    -webkit-box-shadow: 8px 11px 12px -8px rgba(153, 151, 153, 0.71);
    -moz-box-shadow: 8px 11px 12px -8px rgba(153, 151, 153, 0.71);
    box-shadow: 8px 11px 12px -8px rgba(153, 151, 153, 0.71);
    opacity: 1 !important;
    display: block;
    text-align: center;
    vertical-align: middle;
}

.oja-task-pool-cell {
    min-height: 50px;
}

.oja-pool {
    width: 100%;

    align-items: stretch;
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-start;
    overflow-y: scroll;
}

.oja-pool-element {
    flex: 1 1 0px;
    padding: 5px;
    flex-basis: 15%;
}
</style>
<style>
/* No scope style */
.default-theme.splitpanes--horizontal > .splitpanes__splitter {
    background: #dad9d9;
}
.splitpanes__pane {
    /*box-shadow: 0 0 3px rgba(0, 0, 0, 0.2) inset;*/
    justify-content: center;
    align-items: center;
    display: flex;
    position: relative;
}
</style>

<style lang="scss">
.popover-main {
    .popover-body {
        padding: 0 !important;
    }
}
</style>
